 
  //noinspection BadExpressionStatementJS,UnterminatedStatementJS
 define({ 
         ok: "确定",
         cancel: "取消",
         switchPanes: "切换窗口",
         close: "关闭",
         yes: "是",
         no: "否"
     });

